<template>
<v-container>
  <v-card>
    <v-card-title>
      Vermont Schools
      <v-spacer></v-spacer>
      <v-text-field
        append-icon='search'
        label='Search'
        single-line
        hide-details
        v-model='search'
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-bind:search='search'
      v-bind:headers='headers'
      v-bind:items='items'
      v-bind:rows-per-page-items="[400, 100, 10, 5]"
      v-bind:pagination.sync='pagination'
      item-key='name'
      class='elevation-1'
    >
    <template slot='headers' slot-scope='props'>
      <tr>
        <th v-for='header in props.headers' :key='header.text'
          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
          @click='changeSort(header.value)'
        >
          <v-icon>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template slot='items' slot-scope='props'>
        <td>
          <v-btn outline color='indigo' @click.native="openDetails(props.item)">
            {{ props.item.name }}
          </v-btn>
        </td>
        <td class='text-xs-right'>{{ props.item.townam }}</td>
        <td class='text-xs-right'>{{ props.item.schdis }}</td>
        <td class='text-xs-right'>{{ props.item.schcat }}</td>
        <td class='text-xs-right'>{{ props.item.grades }}</td>
        <td class='text-xs-right'>{{ props.item.estsiz }}</td>
    </template>
    </v-data-table>
  </v-card>
</v-container>
</template>

<script>
export default {
  data: () => ({
    max25chars: (v) => v.length <= 25 || 'Input too long!',
    tmp: '',
    search: '',
    pagination: {
      sortBy: 'name'
    },
    selected: [],
    headers: [
      {
        text: 'Schools',
        align: 'left',
        value: 'name'
      },
      { text: 'Town', value: 'townam' },
      { text: 'District', value: 'schdis' },
      { text: 'Type', value: 'schcat' },
      { text: 'Grades', value: 'grades' },
      { text: 'Size (est.)', value: 'estsiz' }
    ]
  }),
  /*
  firebase: {
    items = vtSchoolsRef
  },
  */
  computed: {
    items () {
      return this.$store.getters.verSch
    }
  },
  methods: {
    openDetails (item) {
      const details = this.items.find(i => i === item)
      if (!details) return console.log('Not found')
      console.log(JSON.stringify(details))
      this.$store.dispatch('pickSchool', details)
      this.zoom = 11
      this.$router.push('/')
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    editRow (rowData) {
      let rar = Object.values(rowData)
      // alert('You clicked edit on' + JSON.stringify(rowData))
      this.$store.dispatch('pickSchool'(rar))
      // this.zoom = 11
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toolBox/schoolIndex.vue